import { PhoneType } from "@/schema"
import { v4 as uuidv4 } from "uuid"
import { create } from "zustand"

export interface ContactFormData {
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneExtension: string
  phoneType: PhoneType
  createMore: boolean
  bookId?: string
}

interface ContactStore {
  drafts: Record<string, ContactFormData>
  createDraft: (defaultValues?: Partial<ContactFormData>) => string
  updateDraft: (id: string, updates: Partial<ContactFormData>) => void
  removeDraft: (id: string) => void
}

const DEFAULT_DRAFT: ContactFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  phoneExtension: "",
  phoneType: "mobile",
  createMore: false,
}

export const useContactStore = create<ContactStore>((set) => ({
  drafts: {},
  createDraft: (defaultValues?: Partial<ContactFormData>) => {
    const id = uuidv4()
    set((state) => ({
      drafts: {
        ...state.drafts,
        [id]: { ...DEFAULT_DRAFT, ...defaultValues },
      },
    }))
    return id
  },
  updateDraft: (id, updates) => {
    set((state) => {
      if (!state.drafts[id]) return state

      return {
        drafts: {
          ...state.drafts,
          [id]: {
            ...state.drafts[id],
            ...updates,
          },
        },
      }
    })
  },
  removeDraft: (id) => {
    set((state) => {
      const newDrafts = { ...state.drafts }
      delete newDrafts[id]
      return { drafts: newDrafts }
    })
  },
}))
